<template>
  <div v-html="content" />
</template>

<script>

export default {
  name: 'ToastComponent',

  props: ['content'],

};
</script>
